import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

// import { NgIcon, provideIcons } from '@ng-icons/core';
// import { featherEdit } from '@ng-icons/feather-icons';

import { NgSelectComponent } from '@ng-select/ng-select';

import { CrudService } from '../../core/services/crud.service';

import { ShoppingItemComponent } from '../shopping-item/shopping-item.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-shopping-cart',
  imports: [
    // NgIcon,
    NgSelectComponent,
    FormsModule,
    ShoppingItemComponent,
    CurrencyPipe,
  ],
  // viewProviders: [provideIcons({ featherEdit })],
  templateUrl: './shopping-cart.component.html',
  styles: ``,
})
export class ShoppingCartComponent implements OnInit {
  private crudService = inject(CrudService);

  cartId: string = '';
  cartItems: Array<any> = [];

  products: Array<any> = [];
  productToAdd: any = null;

  inventoryIndex = 0;

  productCount: number = 0;
  productTotal: number = 0;
  discount: number = 0;
  subtotal: number = 0;
  freight: number = 200;
  shipping: number = 10;
  total: number = 0;

  confirmationMessage = '';

  ngOnInit(): void {
    this.getOrCreateCart();

    this.getProductsForSale();
  }

  getProductsForSale() {
    this.crudService.getProductsForSale().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.products = response.body;
        }
      },
    });
  }

  getOrCreateCart() {
    this.crudService.getCartList().subscribe({
      next: (response: any) => {
        if (response.ok) {
          if (response.body.length > 0) {
            this.cartId = response.body[0].id;
            this.cartItems = response.body[0].items;

            this.updateTotals();
          } else {
            this.crudService.createCart().subscribe({
              next: (response: any) => {
                if (response.ok) {
                  if (response.body) {
                    this.cartId = response.id;
                    this.cartItems = [];
                  }
                }
              },
            });
          }
        }
      },
    });
  }

  createCart() {
    this.crudService.createCart().subscribe({
      next: (response: any) => {
        if (response.ok) {
          if (response.body) {
            this.cartId = response.id;
            this.cartItems = [];
          }
        }
      },
    });
  }

  addElement() {
    this.inventoryIndex = 0;

    this.createShoppingItem();
  }

  createShoppingItem() {
    if (this.cartId && this.productToAdd !== null) {
      const newShoppingItem = {
        product_id: this.productToAdd.id,
        quantity: 1,
        // uom_reserved: this.productToAdd.uom_key,
        uom_reserved: 'ROLLS',
        unit_price_at_reservation: this.productToAdd.price_roll,
        color:
          this.productToAdd.inventory_by_combination[this.inventoryIndex].color,
        width:
          this.productToAdd.inventory_by_combination[this.inventoryIndex].width,
      };

      this.crudService.addItemToCart(this.cartId, newShoppingItem).subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.crudService.getCartDetail(this.cartId).subscribe({
              next: (response: any) => {
                if (response.ok) {
                  this.cartItems = response.body.items;

                  this.updateTotals();

                  this.productToAdd = null;
                }
              },
            });
          }
        },
        error: (error: any) => {
          if (error.status === 409 || error.status === 404) {
            if (
              this.inventoryIndex <
              this.productToAdd.inventory_by_combination.length
            ) {
              this.inventoryIndex += 1;

              this.createShoppingItem();
            }
          }
        },
      });
    }
  }

  updateShoppingItem(updatedShoppingItem: any) {
    console.log(updatedShoppingItem);

    this.crudService
      .updateItemInCart(
        updatedShoppingItem.itemId,
        updatedShoppingItem.productToUpdate
      )
      .subscribe({
        next: (response: any) => {
          // console.log(response);
          if (response.ok) {
            this.crudService.getCartDetail(this.cartId).subscribe({
              next: (response: any) => {
                if (response.ok) {
                  this.cartItems = response.body.items;

                  this.updateTotals();
                }
              },
            });
          }
          // this.itemIsUpdated.emit(updatedShoppingItem);
        },
      });
  }

  deleteShoppingItem(cartItem: string) {
    this.crudService.deleteItemInCart(cartItem).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.crudService.getCartDetail(this.cartId).subscribe({
            next: (response: any) => {
              if (response.ok) {
                this.cartItems = response.body.items;

                this.updateTotals();
              }
            },
          });
        }
      },
    });
  }

  // updateCart(updatedItem: any) {
  //   if (this.shopItems.length > 0) {
  //     const index = this.shopItems.findIndex(
  //       (item) => item.product_id === updatedItem.product_id
  //     );

  //     this.shopItems.splice(index, 1, updatedItem);
  //   } else {
  //     this.shopItems.push(updatedItem);
  //   }

  //   this.updateTotals();
  // }

  updateTotals() {
    this.productCount = this.cartItems.reduce(
      (acc, curr) => acc + curr.quantity,
      0
    );
    this.productTotal = this.cartItems.reduce(
      (acc, curr) => acc + curr.quantity * curr.price_reserved,
      0
    );
    this.subtotal = this.productTotal;
    this.total = this.subtotal + this.shipping + this.freight - this.discount;
  }

  createSale() {
    this.crudService
      .createSale(this.cartId, {
        notes: '',
      })
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.confirmationMessage = 'La venta fue exitosa';

            setTimeout(() => {
              this.confirmationMessage = '';
            }, 3000);

            // this.getOrCreateCart();
            this.createCart();
            // console.log();
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }
}
